import { z } from 'zod';

export const AuthTokensSchema = z.object({
  accessToken: z.string().min(1, 'Access token cannot be empty'),
  refreshToken: z.string().min(1, 'Refresh token cannot be empty'),
});

export type IAuthTokensDto = z.infer<typeof AuthTokensSchema>;
